import styled from '@emotion/styled'
export default styled('div')`
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  padding: 0.75rem 0;
`
